<template>
    <Modal :title="$t('customRating.displaySettingsModal.title')"
           width="600"
           :close-on-click-outside="false"
           @close="closeModal()"
    >
        <template v-slot:body>
            <form class="base_margin modal-content" style="margin-top: 0">
                <div class="text_left light_bg_color margin_top">
                    <span class="font_bold">{{$t("common.hint")}}：</span>
                    <br/>
                    <span>{{$t("customRating.displaySettingsModal.hintText")}}</span>
                </div>
                <div class="flex flex_start_bottom">
                    <md-checkbox v-model="form.showRating1" class="flex_1" style="padding-top: 5px">
                        {{$t('customRating.table.showRating1')}}
                    </md-checkbox>
                    <md-field class="flex_2">
                        <label>{{ $t("customRating.table.rating1") }} {{ $t("common.name") }}</label>
                        <md-input v-model="form.nameRating1"></md-input>
                    </md-field>
                </div>
                <div class="flex flex_start_bottom">
                    <md-checkbox v-model="form.showRating2" class="flex_1">
                        {{$t('customRating.table.showRating2')}}
                    </md-checkbox>
                    <md-field class="flex_2">
                        <label>{{ $t("customRating.table.rating2") }} {{ $t("common.name") }}</label>
                        <md-input v-model="form.nameRating2"></md-input>
                    </md-field>
                </div>
                <div class="flex flex_start_bottom">
                    <md-checkbox v-model="form.showRating3" class="flex_1">
                        {{$t('customRating.table.showRating3')}}
                    </md-checkbox>
                    <md-field class="flex_2">
                        <label>{{ $t("customRating.table.rating3") }} {{ $t("common.name") }}</label>
                        <md-input v-model="form.nameRating3"></md-input>
                    </md-field>
                </div>
            </form>
            <div class="flex flex_between">
                <md-button class="md-blank" @click="closeModal()">{{ $t("common.button.cancel") }}</md-button>
                <md-button
                    class="md-primary"
                    @click="submit"
                >{{ $t("common.button.submit") }}
                </md-button>
            </div>
        </template>
    </Modal>
</template>

<script>
import Modal from "@/components/templates/modal/Modal";
import MoneyAmountInput from "@/components/templates/common/MoneyAmountInput";
import {customRatingsApi} from "@/common/api/customRatingsApi";

export default {
    components: {
        Modal,
        MoneyAmountInput,
    },
    mounted() {
		this.loadData();
    },
    data() {
        return {
            form: {
				showRating1: null,
				showRating2: null,
				showRating3: null,
				nameRating1: null,
				nameRating2: null,
				nameRating3: null,
            }
        };
    },
    methods: {
	    loadData() {
			customRatingsApi.inspection.getConfig()
                .then(res => {
                	this.form = {
						showRating1: res.showRating1,
						showRating2: res.showRating2,
					    showRating3: res.showRating3,
						nameRating1: res.nameRating1,
                        nameRating2: res.nameRating2,
                        nameRating3: res.nameRating3
					}
                })
                .catch(e => {
					this.toast(e);
                })
	    },
        closeModal() {
            this.$emit("close");
        },
        submit() {
            this.$emit("submit",this.form)
        },
    },
};
</script>